import { useContext } from 'react';
import { CalculatorContext } from './CalculatorProvider';

export default function useCalculator() {
  return useContext(CalculatorContext);
}
